import { DisplayImageConfigType } from '../../../lib/config';
import { Component } from './component';
import {
  ComponentBuilder,
  FunctionComponent
} from '../../component-builder/types';

export class BorderLayerBuilder
  implements ComponentBuilder<DisplayImageConfigType> {
  build(
    adContext: AdContext,
    config: DisplayImageConfigType
  ): FunctionComponent {
    return Component;
  }

  isInjectable(adContext: AdContext, config: DisplayImageConfigType): boolean {
    return config.useBorderLayer;
  }
}
